import type { TypePolicies } from "@apollo/client"

export const tenantPrivacyTypePolicies: TypePolicies = {
  // The privacy editor's whole read is ONE entity keyed by tenant, and every
  // policy mutation returns that same shape — keying it means a mutation's
  // payload lands on the record the open page is rendering, so the preset
  // highlight and the fine-tuning table update together without a refetch.
  TenantPrivateDataVisibilityState: {
    keyFields: ["TenantId"],
    fields: {
      // Policy rows carry no identity of their own (the dataIdFromObject
      // fallback would collapse them on ExternalSourceCode-less objects);
      // the returned list IS the new truth and replaces the old wholesale.
      Policies: { merge: false },
    },
  },
  // The summary is reached from two parents — the editor's state and
  // Tenant.PrivateDataVisibilitySummary on the teams list and team header.
  // Keyed by tenant it is one record under both, so the summary a policy
  // mutation returns moves the list's and the header's pill as well, with
  // no refetch and no chance of the three disagreeing.
  TenantPrivateDataVisibilitySummary: {
    keyFields: ["TenantId"],
  },
}
